(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('authorization', authorization);

    authorization.$inject = ['$http', '$window', '$q', 'endPoints'];

    function authorization($http, $window, $q, endPoints) {
        var bearerToken = $window.localStorage.getItem('bearerToken');
        var service = {
            getStoredToken: getStoredToken,
            getToken: doLogin,
            setBearerHeader: setBearerHeader,
            doLogin: doLogin,
            logout: logout,
            isOnline: false,
            hasToken: hasToken,
            hasLoaded: false
        };
        return service;

        function getStoredToken() {
            return bearerToken;
        }

        function doLogin(user, password) {
            var deferred = $q.defer();
            var request = {
                method: 'POST',
                url: endPoints.authorization.getToken,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    var str = [];
                    for (var p in obj) {
                        if (obj.hasOwnProperty(p)) {
                            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
                        }
                    }
                    return str.join('&');
                },
                data: {
                    'client_id': 'web_client',
                    'client_secret': 'InvestelWeb2016',
                    'username': user,
                    'password': password,
                    'grant_type': 'password',
                    'scope': 'api openid',
                    'scope_secret': 'InvesfleetApi2016'
                }
            };
            $http(request).then(
                function (response) {
                    service.isOnline = true;
                    bearerToken = response.data.access_token;
                    $window.localStorage.setItem('bearerToken', bearerToken);
                    deferred.resolve(true);
                },
                function (response) {
                    service.isOnline = false;
                    deferred.reject(false);
                });
            return deferred.promise;
        }

        function logout() {
            $window.localStorage.removeItem('bearerToken');
            service.isOnline = false;
            bearerToken = null;
            $window.location = './';
        }

        function setBearerHeader($httpProvider) {
            if (bearerToken) {
                $httpProvider.defaults.headers.common.authorization = 'Bearer ' + bearerToken;
            }            
        }

        function hasToken(){
            return bearerToken !== null;
        }

    }
})();